import { EAssetType } from 'constants/enums';
import { POPUP_DEFAULTS } from 'views/OfferDesign/OfferDesign.consts';

import { TextFieldConfig, UploadFieldConfig } from './PopupFormFields.types';

export { POPUP_DEFAULTS };

export const FONT_WEIGHT_OPTIONS = [
  { value: 'normal', label: 'Regular' },
  { value: 'medium', label: 'Medium' },
  { value: 'bold', label: 'Bold' }
];

export const TEXT_FIELDS: TextFieldConfig[] = [
  { label: 'Name', name: 'name', placeholder: 'Name', uniqueFlag: 'isNameUnique' },
  { label: 'External ID', name: 'externalId', placeholder: 'External ID', uniqueFlag: 'isExternalIdUnique' }
];

export const UPLOAD_FIELDS: UploadFieldConfig[] = [
  { title: 'Background Image', fieldName: 'backgroundImage', forceType: EAssetType.BG_BUNDLE, tooltip: 'Upload a background image for the popup offer card', isRequired: true },
  { title: 'Badge Image', fieldName: 'badgeCoverImage', forceType: EAssetType.BG_BUNDLE, tooltip: 'Upload a badge image for the popup' }
];
